import React, { Component } from 'react';
import { func, object, number, array, string } from 'prop-types';
import classnames from 'classnames';
import { GRADE_TABS } from '../ViewGrade';
import { interpolateRgbBasis } from 'd3';
export default class ViewGradeSlideoutHeader extends Component {
  static propTypes = {
    backToList: func,
    hideSlideout: func,
    clickGrade: func,
    modelId: string,
    smaData: array,
    prevGradeIdx: number,
    nextGradeIdx: number,
    scrollRef: object,
    currentTab: number,
    basis: string,
    basisOptions: array
  };

  constructor(props) {
    super(props);
    this.clickNextGrade = this.clickNextGrade.bind(this);
    this.clickPrevGrade = this.clickPrevGrade.bind(this);
  }

  clickPrevGrade() {
    const { clickGrade, modelId, smaData, prevGradeIdx, scrollRef, basis } = this.props;
    clickGrade(modelId, smaData[prevGradeIdx], prevGradeIdx, undefined, basis).then(() => {
      scrollRef.current.scrollTop = 0;
    });
  }

  clickNextGrade() {
    const { clickGrade, modelId, smaData, nextGradeIdx, scrollRef, basis } = this.props;
    clickGrade(modelId, smaData[nextGradeIdx], nextGradeIdx, undefined, basis).then(() => {
      scrollRef.current.scrollTop = 0;
    });
  }

  render() {
    const { prevGradeIdx, nextGradeIdx } = this.props;
    return (
      <div className={'slideout-header'}>
        <section className="slideout-header__left sma-view-grade__header-left">
          <span className="smal-view-grade__go-back" onClick={this.props.backToList}>
            <i className="icon-reply go-back" />
            <span id="sma-return-to-all-grades">Return to All Grades</span>
          </span>
        </section>
        <section className="slideout-header__right sma-view-grade__header-right">
          <div className="sma-grade-nav">
            <div
              className={classnames(
                { 'hide-visibility': prevGradeIdx == null },
                'sma-header-text__button sma-prev-grade'
              )}
              onClick={this.clickPrevGrade}
            >
              {'< Prev Grade'}
            </div>
            <div
              className={classnames({ 'hide-visibility': prevGradeIdx == null && nextGradeIdx == null }, 'sma-divider')}
            >
              |
            </div>
            <div
              className={classnames(
                { 'hide-visibility': nextGradeIdx == null },
                'sma-header-text__button sma-next-grade'
              )}
              onClick={this.clickNextGrade}
            >
              {'Next Grade >'}
            </div>
          </div>
          <button className="slideout-header__button" onClick={this.props.hideSlideout}>
            <i className="slideout-header-button__icon icon-cancel"></i>
          </button>
        </section>
      </div>
    );
  }
}
